export default __webpack_public_path__ + "static/media/kubernetes.67e424b5.png";